import React, { useState } from "react";

const Ordered = ({ card, onBack, onGoBackToServices }) => {
  const [selectedCookie, setSelectedCookie] = useState("Choose an Option");
  const [smallQuantity, setSmallQuantity] = useState(1);
  const [showSmallDropdown, setShowSmallDropdown] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [showCookieDropdown, setShowCookieDropdown] = useState(false);
  const [showQuantityDropdown, setShowQuantityDropdown] = useState(false);

  return (
    <div
      style={{
        color: "#FFF",
        fontFamily: "Manrope",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        marginTop: "20px", 
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          alignItems: "flex-start",
          
        }}
      >
        <h2
          style={{
            color: "#FFFFFF",
            fontFamily: "Manrope",
            fontSize: "28px",
            fontWeight: 600,
            margin: 0,
          }}
        >
          Get a Package
        </h2>
      </div>

      {/* New Top Layout */}
      <div
        style={{
          display: "flex",
          padding: "12px",
          alignItems: "center",
          gap: "12px",
          flex: "1 0 0",
          borderRadius: "16px",
          background: "rgba(255, 255, 255, 0.15)",
          backdropFilter: "blur(30px)",
          flexDirection: "column",
        }}
      >
        {/* Inner Flex */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flex: "1 0 0",
            width: "100%",
          }}
        >
          {/* Image and Text */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flex: "1 0 0",
            }}
          >
            <img
              src={card.image}
              alt="Box"
              style={{
                width: "51px",
                height: "48px",
                aspectRatio: "17/16",
                borderRadius: "8px",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 5,
                flex: "1 0 0",
                overflow: "hidden",
                color: "#FFF",
                textOverflow: "ellipsis",
                fontFamily: "Manrope",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "120%",
                letterSpacing: "-0.36px",
              }}
            >
              Welcome Treat Box
            </div>
          </div>
        </div>
        </div>

        {/* Divider */}
        <div
          style={{
            
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "8px",
          }}
        >
          <div
          style={{
            width: "85px",
            height: "0px",
            marginTop: "28px",
            transform: "rotate(90deg)",
            color: "rgba(255,255,255,0.4)",
            fontFamily: "Manrope",
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: "420%",
            letterSpacing: "-0.3px",
          }}
        >
            --------------
          </div>
        </div>

        {/* Step 1 - Order Placed */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            alignSelf: "stretch",
          }}
        >
          <div style={{ width: "40px", height: "40px", aspectRatio: "1/1" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                opacity="0.5"
                d="M3.47735 4.58526C3.70633 3.93398 4.41991 3.59164 5.07119 3.82061L5.57352 3.99722C6.60107 4.35844 7.47379 4.66523 8.1606 5.00223C8.89498 5.36257 9.52473 5.80646 9.99837 6.49957C10.4683 7.18731 10.6624 7.94183 10.7519 8.76913C10.792 9.13947 10.8131 9.54937 10.8243 9.99992H28.5546C31.3629 9.99992 33.8909 9.99992 34.6308 10.9617C35.3707 11.9235 35.0814 13.3727 34.5029 16.2712L33.6699 20.3124C33.1447 22.8605 32.8821 24.1346 31.9626 24.8839C31.0431 25.6333 29.7422 25.6333 27.1405 25.6333H18.3024C13.6542 25.6333 11.3301 25.6332 9.88612 24.1102C8.44212 22.5872 8.33672 20.9692 8.33672 16.0666L8.33672 11.7304C8.33672 10.4972 8.33502 9.67184 8.26643 9.03817C8.20088 8.43259 8.08471 8.13022 7.93428 7.91007C7.78751 7.6953 7.56473 7.49459 7.05935 7.24661C6.52128 6.9826 5.79002 6.72335 4.67734 6.33215L4.24199 6.17909C3.59072 5.95012 3.24837 5.23653 3.47735 4.58526Z"
                fill="#F5F7F3"
              />
              <path
                d="M12.5 30C13.8807 30 15 31.1193 15 32.5C15 33.8807 13.8807 35 12.5 35C11.1193 35 10 33.8807 10 32.5C10 31.1193 11.1193 30 12.5 30Z"
                fill="#F5F7F3"
              />
              <path
                d="M27.5 30.0001C28.8807 30.0001 30 31.1194 30 32.5001C30 33.8808 28.8807 35.0001 27.5 35.0001C26.1193 35.0001 25 33.8808 25 32.5001C25 31.1194 26.1193 30.0001 27.5 30.0001Z"
                fill="#F5F7F3"
              />
              <path
                d="M25.9 15.8621C26.3761 15.3622 26.3568 14.5709 25.8569 14.0948C25.357 13.6187 24.5657 13.638 24.0896 14.1379L20.2329 18.1875L19.2333 17.1379C18.7572 16.638 17.966 16.6187 17.4661 17.0948C16.9661 17.5709 16.9468 18.3622 17.423 18.8621L19.3277 20.8621C19.5636 21.1098 19.8908 21.25 20.2329 21.25C20.575 21.25 20.9021 21.1098 21.1381 20.8621L25.9 15.8621Z"
                fill="#F5F7F3"
              />
            </svg>
          </div>
          <div
            style={{
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              fontWeight: 700,
              lineHeight: "120%",
              letterSpacing: "-0.3px",
            }}
          >
            Your Order is Placed
          </div>
        </div>

        {/* Divider */}
        <div
          style={{
            width: "85px",
            height: "0px",
            marginTop: "24px",
            transform: "rotate(90deg)",
            color: "rgba(255,255,255,0.4)",
            fontFamily: "Manrope",
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: "420%",
            letterSpacing: "-0.3px",
          }}
        >
          --------------
        </div>

        {/* Step 2 - On Way */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            alignSelf: "stretch",
            opacity: 0.4,
          }}
        >
          <div style={{ width: "40px", height: "40px" }}>
            {/* Envelope Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                d="M14.0398 34.3637C16.9658 35.8993 18.4288 36.667 20.0026 36.667V20.0004L4.3993 11.7881C4.37633 11.825 4.35377 11.8623 4.3316 11.8999C3.33594 13.5908 3.33594 15.6948 3.33594 19.9029V20.0978C3.33594 24.3059 3.33594 26.4099 4.3316 28.1008C5.32726 29.7916 7.12032 30.7326 10.7064 32.6145L14.0398 34.3637Z"
                fill="white"
                fillOpacity="0.6"
              />
              <path
                opacity="0.7"
                d="M29.2979 7.38603L25.9646 5.63678C23.0386 4.10126 21.5755 3.3335 20.0017 3.3335C18.428 3.3335 16.9649 4.10125 14.0389 5.63677L10.7056 7.38603C7.1993 9.22603 5.40713 10.1665 4.39844 11.7879L20.0017 20.0002L35.6051 11.7879C34.5964 10.1665 32.8042 9.22604 29.2979 7.38603Z"
                fill="white"
              />
              <path
                opacity="0.5"
                d="M35.671 11.8999C35.6488 11.8623 35.6263 11.825 35.6033 11.7881L20 20.0004V36.667C21.5738 36.667 23.0368 35.8993 25.9629 34.3637L29.2962 32.6145C32.8823 30.7326 34.6753 29.7916 35.671 28.1008C36.6667 26.4099 36.6667 24.3059 36.6667 20.0978V19.9029C36.6667 15.6948 36.6667 13.5908 35.671 11.8999Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            style={{
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              fontWeight: 700,
              lineHeight: "120%",
              letterSpacing: "-0.3px",
            }}
          >
            Your order is on way
          </div>
        </div>

        {/* Divider */}
        <div
          style={{
            width: "85px",
            height: "0px",
            marginTop: "24px",
            transform: "rotate(90deg)",
            color: "rgba(255,255,255,0.4)",
            fontFamily: "Manrope",
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: "420%",
            letterSpacing: "-0.3px",
          }}
        >
          --------------
        </div>

        {/* Step 3 - Delivered */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            alignSelf: "stretch",
            opacity: 0.4,
          }}
        >
          <div style={{ width: "40px", height: "40px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
            >
              <path
                opacity="0.5"
                d="M34.2285 34.2261C36.6693 31.7853 36.6693 27.8569 36.6693 20.0002C36.6693 12.1434 36.6693 8.21505 34.2285 5.77427C31.7877 3.3335 27.8593 3.3335 20.0026 3.3335C12.1459 3.3335 8.21749 3.3335 5.77671 5.77427C3.33594 8.21505 3.33594 12.1434 3.33594 20.0002C3.33594 27.8569 3.33594 31.7853 5.77671 34.2261C8.21749 36.6668 12.1459 36.6668 20.0026 36.6668C27.8593 36.6668 31.7877 36.6668 34.2285 34.2261Z"
                fill="white"
              />
              <path
                d="M29.0883 11.5058C29.6374 11.9242 29.7434 12.7085 29.325 13.2576L17.8965 28.2576C17.6689 28.5563 17.3191 28.7369 16.9438 28.7494C16.5685 28.7619 16.2075 28.605 15.9605 28.3221L10.7224 22.3221C10.2684 21.8021 10.322 21.0124 10.842 20.5584C11.3621 20.1044 12.1517 20.1579 12.6057 20.678L16.8363 25.5239L27.3365 11.7425C27.7548 11.1934 28.5392 11.0874 29.0883 11.5058Z"
                fill="white"
              />
            </svg>
          </div>
          <div
            style={{
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              fontWeight: 700,
              lineHeight: "120%",
              letterSpacing: "-0.3px",
            }}
          >
            Package Delivered
          </div>
        </div>
      

      {/* Go back to services */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "8px",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            padding: "8px 16px",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderRadius: "17px",
            border: "1px solid rgba(255, 255, 255, 0)",
            background: "#7EB3AB",
            cursor: "pointer",
          }}
          onClick={onGoBackToServices}
        >
          <span
            style={{
              color: "#FFF",
              fontFamily: "Manrope",
              fontSize: "15px",
              fontWeight: 700,
              lineHeight: "120%",
              letterSpacing: "-0.3px",
            }}
          >
            Go back to services page
          </span>
        </div>
      </div>
    </div>
  );
};

export default Ordered;
